import { Component, inject } from '@angular/core';

import { DownloadFeedbackService } from '../../../core/services/download-feedback.service';
import { UiPreferencesService } from '../../../core/services/ui-preferences.service';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-download-success-overlay',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './download-success-overlay.component.html',
  styleUrl: './download-success-overlay.component.css'
})
export class DownloadSuccessOverlayComponent {
  private readonly downloadFeedback = inject(DownloadFeedbackService);

  protected readonly feedback = this.downloadFeedback.feedback;
  protected readonly darkMode = inject(UiPreferencesService).darkMode;

  protected dismiss(): void {
    this.downloadFeedback.dismiss();
  }
}
